import { User } from '@/core/models/user';

export function isDistributorSupervisorAccess(user: User | null | undefined): boolean {
  return user?.type === 'SUPPORT' && user?.isDistributorSupervisor === true;
}
